module.exports = __webpack_public_path__ + "img/prizeIcon.57a91331.png";